import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import Routers from './Routes';
import { useDispatch } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import { setUserData } from './ReduxToolkit/Reducers/AuthSlice';
function App() {
  const dispatch = useDispatch();
  
  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    
    if (storedToken) {
      try {
        const decodedToken: any = jwtDecode(storedToken);
        dispatch(setUserData({
          nameidentifier: decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'],
          sub: decodedToken['sub'],
          email: decodedToken['email'],
          jti: decodedToken['jti'],
          ContactNo: decodedToken['ContactNo'],
          token: storedToken,
        }));
      } catch (error) {
        console.error("Error decoding token", error);
      }
    }
  }, [dispatch]);

  return (
    <>
      <Routers />
      <ToastContainer position="bottom-right" />
    </>
  );
}

export default App;
